import React, { useState } from "react";
import { Carousel } from "react-bootstrap";

import deal1 from "../../assets/images/deal1.png";
import deal2 from "../../assets/images/deal2.webp";

import BirthdayPopup from "../birthdayPopup/BirthdayPopup";

import "../carousel/Carousel.css";

const BootstrapCarousel = () => {
  const [showBirthdayPopup, setShowBirthdayPopup] = useState(false);

  return (
    <section className="hero-carousel-section">
      <Carousel
        fade
        interval={6000}
        pause={false}
        indicators
        controls
        className="hiro-carousel"
      >
        <Carousel.Item>
          <div className="hiro-slide">
            <img
              src={deal1}
              alt="Free birthday meal promotion"
              loading="eager"
              fetchPriority="high"
            />

            <div className="hiro-overlay"></div>

            <div className="hiro-caption">
              <p className="hiro-tag">Celebrate With Hiro</p>

              <h1>
                FREE BIRTHDAY
                <br />
                MEAL 🎂
              </h1>

              <p className="hiro-description">
                Enjoy a free birthday meal on your special day with a valid
                photo I.D.
              </p>

              <button
                type="button"
                className="hiro-button"
                onClick={() => setShowBirthdayPopup(true)}
              >
                LEARN MORE
              </button>
            </div>
          </div>
        </Carousel.Item>

        <Carousel.Item>
          <div className="hiro-slide">
            <img
              src={deal2}
              alt="Self serve hibachi"
              loading="eager"
              fetchPriority="high"
            />

            <div className="hiro-overlay"></div>

            <div className="hiro-caption">
              <p className="hiro-tag">Fresh • Hot • Interactive</p>

              <h1>
                TRY OUR
                <br />
                HIBACHI 🔥
              </h1>

              <p className="hiro-description">
                Pick your ingredients and enjoy the hibachi experience fresh
                from the grill.
              </p>

              <button
                type="button"
                className="hiro-button"
                onClick={() => (window.location.href = "/buffet-pricing")}
              >
                VIEW MENU
              </button>
            </div>
          </div>
        </Carousel.Item>
      </Carousel>

      {showBirthdayPopup && (
        <BirthdayPopup onClose={() => setShowBirthdayPopup(false)} />
      )}
    </section>
  );
};

export default BootstrapCarousel;
